
<div class="main-wrapper" *ngIf="campaings?.hits?.length">
  <div class="container">
    <div class="heading text-center">{{section?.header}}</div>
    <div class="divider"></div>

    <!-- Fundraiser listings -->
    <div class="row flex-center">
      <div class="col-lg-4 col-md-4 col-sm-12 campaign" *ngFor="let item of campaings?.hits">
        <app-widget [widgetData]="item"
                    [currency]="utilService.currency | async"
                    [currencyIcon]="utilService.getCurrencyIcon(utilService.currency | async)">
        </app-widget>
      </div>
    </div>

    <!-- Load more fundraisers -->
    <div *ngIf="campaings?.estimatedTotalHits !== campaings?.hits?.length" class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="load-more">
          <a (click)="getCampaigns(campaings?.hits?.length)">
            <span *ngIf="!isLoading">Load More</span>
            <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
